<template>
  <div class="setting">
    <line-text
      v-if="!_isFeishuClient"
      class="fix-padding-left"
      :content="$t('profile.setting.phoneNumber')"
      :data="userPhone"
      link
      @click="handleClick('phone')" />
    <line-text
      class="fix-padding-left"
      :content="$t('profile.setting.email')"
      :data="userMail"
      link
      @click="handleClick('email')" />
    <line-text
      v-if="!_isFeishuClient"
      class="fix-padding-left"
      :content="$t('profile.setting.modifyPassword')"
      link
      @click="handleClick('password')" />
    <line-text
      v-if="!_isFeishuClient"
      class="fix-padding-left"
      :content="$t('profile.setting.thirdAccount')"
      link
      @click="linkToThird" />
    <line-text
      class="fix-padding-left first-line"
      :content="$t('profile.setting.about')"
      :data="'V ' + version"
      link
      @click="clickAbout" />

    <cube-button v-if="!_isFeishuLark" class="btn-logout" :light="true" @click="handleLogout">
      {{ $t('profile.setting.logout') }}
    </cube-button>
  </div>
</template>

<script>
import LineText from '@/components/line-text/line-text.vue'
import apis from '../../../api'
import { mapMutations, mapState } from 'vuex'
import ParamsCatchMixin from '@/mixin/params-catch.mixin.js'
import FeishuClientMixin from '@/mixin/feishu-client.mixin'
import {
  SET_ACCOUNT_INFO,
  CLEAR_AUTH_STORE
} from '@/store/auth.store.js'
import {
  SET_CURRENT_FIELD
} from '@/store/profile.store.js'
export default {
  components: {
    LineText
  },
  mixins: [ParamsCatchMixin, FeishuClientMixin],
  data() {
    return {
      version: '1.0.0'
    }
  },
  computed: {
    ...mapState({
      accountInfo: (state) => state.authModule.accountInfo,
      currentField: (state) => state.profileModule.currentField
    }),
    userPhone() {
      return this.accountInfo && this.accountInfo.userInfo ? this.accountInfo.userInfo.phone : ''
    },
    userMail() {
      return this.accountInfo && this.accountInfo.userInfo ? this.accountInfo.userInfo.email : ''
    }
  },
  created() {
    this.queryAccountInfo()
  },
  methods: {
    ...mapMutations('authModule', {
      setAccountInfo: SET_ACCOUNT_INFO,
      clearAuthStore: CLEAR_AUTH_STORE
    }),
    ...mapMutations('profileModule', {
      setCurrentField: SET_CURRENT_FIELD
    }),
    linkToThird() {
      this.$router.push({
        name: 'third-account',
        params: {
          orgId: this.orgId
        }
      })
    },
    handleClick(type) {
      const TITLE_MAP = {
        'phone': '修改手机号',
        'email': '修改邮箱',
        'password': '修改密码'
      }
      this.setCurrentField({ editType: type })
      this.$router.push({
        name: 'multi-line-profile',
        params: {
          orgId: this.orgId
        },
        query: {
          title: TITLE_MAP[type]
        }
      })
    },
    clickAbout() {
      this.$router.push({
        name: 'about'
      })
    },
    queryAccountInfo() {
      const request = { ...apis.ACCOUNT.QUERY_ACCOUNT_INFO }
      this.$request(request)
        .asyncThen(
          (resp) => {
            this.setAccountInfo(resp.data)
          },
          () => {}
        )
        .asyncErrorCatch((error) => {})
    },
    clearStore() {
      try {
        // 清空vuex数据
        this.clearAuthStore()
      } catch (error) {
        console.error(error)
      }
      this.$router.replace({
        name: 'login'
      })
    },
    handleLogout() {
      this.$confirm({
        message: '是否确认退出登录？',
        okConfig: {
          onOk: () => {
            const request = {
              ...apis.ACCOUNT.USER_LOGOUT
            }
            this.$request(request).asyncThen((resp) => {
              this.clearStore()
            }, (error) => {
              console.error(error)
              this.clearStore()
            })
              .asyncErrorCatch((error) => {
                console.error(error)
                this.clearStore()
              })
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.setting {
  height: 100%;
  width: 100%;
  background: $--app-body-bgColor;
  overflow-x: hidden;
  .btn-logout {
    margin-top: 2.286rem;
    background: $--app-light-color;
    height: 3.143rem;
  }
  .first-line {
    margin-top: .571rem;
  }
}
</style>
